import Axios from 'axios';

export const NEW_EDITION = 'NEW_EDITION'; // NEW AND COPY EDITION
export const SET_VARIABLES = 'SET_VARIABLES';
// export const SAVE_SETTINGS_EDIT = "SAVE_SETTINGS_EDIT";
// export const SAVE_SETTINGS_NEW = "SAVE_SETTINGS_NEW";
export const GET_PDF_CAMP = 'GET_PDF_CAMP';
export const MARK_EDITION = 'MARK_EDITION';
export const SET_PREVIEW_IMAGE = 'SET_PREVIEW_IMAGE';
export const DUPLICATE_CAMPAIGNS = 'DUPLICATE_CAMPAIGNS'; // COPY CAMPAIGN AND EDITONS TO USER

export const GET_PRINT_DATA_CAMP = 'GET_PRINT_DATA_CAMP';

// --------- campaigns --------------------------------
export function setVariables(key) {
  return {
    type: SET_VARIABLES,
    payload: key,
  };
}

// ------------------- CampaignDetails.js --------------------------

export function newEditionR(params) {
  return {
    type: NEW_EDITION,
    payload: Axios.post('/api/editions.json', { json: JSON.stringify(params) }).then(({ data }) => data),
  };
}

export function setPreviewImageR(editionId) {
  return {
    type: SET_PREVIEW_IMAGE,
    payload: Axios.put('/api/editions/' + editionId + '/preview.json', {}).then(({ data }) => data),
  };
}

// -------------Edition.js -----------------------------------

export function getPDFR(api, editionId, messages) {
  const payloadData = [];
  payloadData.messages = messages;
  return {
    type: GET_PDF_CAMP,
    payload: Axios.post('/api/printjob/' + api + '/' + editionId + '.json', {}).then(({ data }) => {
      payloadData.data = data;
      return payloadData;
    }),
  };
}

export function getPrintDataR(editionId, messages, printDataLink) {
  const payloadData = [];
  payloadData.messages = messages;
  if (printDataLink) {
    payloadData.data = printDataLink
    return {
      type: GET_PRINT_DATA_CAMP,
      payload: payloadData
    };
  }
}


export function duplicateCampaignAndEditionsR(params, campaignId) {
  const payloadData = [];
  payloadData.params = params;
  return {
    type: DUPLICATE_CAMPAIGNS,
    payload: Axios.post('/api/duplicates/' + campaignId + '/campaigns.json ', params).then(({ data }) => {
      payloadData.data = data;
      return payloadData;
    }),
  };
}
